import React from 'react'
import styled from 'styled-components/macro'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import { CenteredRow } from '../Page/Layout'

export const WizardNavigationWrapper = styled(CenteredRow)`
  &&& {
    margin-top: 40px !important;
  }
`

export const WizardNavWrapper = styled.div`
  text-align: center;

  .nav-buttons {
    padding-bottom: 1em;

    .ant-btn {
      min-width: 100px;
      font-size: 14px;
      font-weight: 900;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.71;
      letter-spacing: normal;
      text-align: center;

      &.btn-back {
        background-color: ${({ theme: { colors } }) => colors.paleGrey};
        color: ${({ theme: { colors } }) => colors.main};
      }
    }
    .ant-btn + .ant-btn {
      margin-left: 3em;
    }
  }
`

export type NavProps = {
  totalSteps?: number
  currentStep?: number
  previousDisabled?: boolean
  nextDisabled?: boolean
  nextLoading?: boolean
  previousStep?: () => void
  nextStep?: () => void
  nextStepText?: string
  previousStepText?: string
}

export const WizardNav = ({
  previousDisabled,
  nextDisabled,
  previousStep,
  nextStep,
  nextLoading,
  nextStepText,
  previousStepText
}: NavProps) => {
  const { t } = useTranslation('common')
  return (
    <WizardNavWrapper>
      <div className="nav-buttons">
        <Button className="btn-back" disabled={previousDisabled} onClick={previousStep}>
          {previousStepText || t('Back')}
        </Button>
        <Button type="primary" disabled={nextDisabled} loading={nextLoading} onClick={nextStep}>
          {nextStepText || t('Continue')}
        </Button>
      </div>
    </WizardNavWrapper>
  )
}
